import { render, staticRenderFns } from "./PlannedBudget.vue?vue&type=template&id=23f5ce1f&scoped=true"
import script from "./PlannedBudget.vue?vue&type=script&lang=js"
export * from "./PlannedBudget.vue?vue&type=script&lang=js"
import style0 from "./PlannedBudget.vue?vue&type=style&index=0&id=23f5ce1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5ce1f",
  null
  
)

export default component.exports